import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["parentId", "playlistId"],
  _excluded2 = ["data"];
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from 'react-query';
import i18n from 'i18n';
import api from 'utils/api';
import { ASSET_READ, hasPrivilege } from 'utils/privileges';
import { getAssetIcon } from 'utils/icons';
import { getAdminContentLink } from 'utils/getAdminContentLink';
import isAdmin from 'utils/session/isAdmin';
import assetKeys from './queryKeys';
var basicAssetFields = ['id', 'name', 'parent_id', 'domain_id', 'type', 'customType', 'fileFormat'];
function fetchPopularAsset(_x) {
  return _fetchPopularAsset.apply(this, arguments);
}
function _fetchPopularAsset() {
  _fetchPopularAsset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var parentId, playlistId, q, resp;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          parentId = _ref.parentId, playlistId = _ref.playlistId;
          q = {
            fields: [{
              _count: '_count'
            }],
            filter: {
              action: 'open',
              category: 'asset'
            },
            orderby: '_count DESC',
            limit: 25
          };
          if (parentId) {
            q.fields.push({
              asset: basicAssetFields
            });
            q.groupby = 'asset.id';
            q.filter.asset = {
              parent_id: parentId
            };
          }
          if (playlistId) {
            q.fields.push({
              commonAsset: basicAssetFields
            });
            q.groupby = 'commonAsset.id';
            q.filter.commonAsset = {
              assetCollections: {
                collection_id: playlistId
              }
            };
          }
          _context2.next = 6;
          return api('get', '/api/query/events', q);
        case 6:
          resp = _context2.sent;
          return _context2.abrupt("return", resp.items.map(function (item) {
            var openString = i18n.t('analytics_open', {
              count: item._count
            });
            var asset = item.asset || item.commonAsset;
            return {
              icon: getAssetIcon(asset),
              title: asset.name,
              value: openString,
              link: hasPrivilege(ASSET_READ) && getAdminContentLink(asset)
            };
          }));
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchPopularAsset.apply(this, arguments);
}
function useFetchPopularAssetsInFolderOrPlaylist(_ref2) {
  var parentId = _ref2.parentId,
    playlistId = _ref2.playlistId,
    queryOptions = _objectWithoutProperties(_ref2, _excluded);
  function getAsset() {
    return _getAsset.apply(this, arguments);
  }
  function _getAsset() {
    _getAsset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", fetchPopularAsset({
              parentId: parentId,
              playlistId: playlistId
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getAsset.apply(this, arguments);
  }
  var _useQuery = useQuery(assetKeys.popularAssets(parentId, playlistId), getAsset, _objectSpread(_objectSpread({
      enabled: isAdmin()
    }, queryOptions), {}, {
      staleTime: 5 * 60 * 1000
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
}
export default useFetchPopularAssetsInFolderOrPlaylist;